const EditTypeTagStyles = () => ({});

export default EditTypeTagStyles;
